export default __webpack_public_path__ + "static/media/buildings_only.dc6c3640.svg";